export default __webpack_public_path__ + "static/media/174hz-Deeper-Sleep.730fe4c7.ogg";